export const getStreamChatKey = "k5jz2xh8hg9w";